import { SecondaryButton } from '@chegg-ui/button'
import { colors, font, spacing } from '@chegg-ui/theme'
import styled from 'styled-components'

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${spacing.px8};
  padding-top: ${spacing.px12};
`

export const UpdateButton = styled(SecondaryButton).attrs({
  variant: 'default',
  size: 'small',
})`
  && {
    background-color: ${({ disabled }) => (disabled ? colors.grey100 : '#2E8AEE')};
    color: ${({ disabled }) => (disabled ? colors.grey500 : colors.white)};
    font-size: ${font.size.px14};
    font-weight: ${font.weight.bold};
  }

  ${({ disabled }) =>
    disabled
      ? ''
      : `
    &&:hover,
    &&:focus {
      background-color: ${colors.sky700};
    }
  `};
`

export const Sentence = styled.span`
  font-size: ${font.size.px16};
`

interface HighlightedTextProps {
  added: boolean
  removed: boolean
}

export const HighlightedText = styled.span<HighlightedTextProps>`
  font-weight: ${(props) => (props.added ? font.weight.bold : '')};
  color: ${colors.grey900};
`
